<template>
  <b-popover
    variant="info"
    :target="target_id"
    triggers="hover"
    placement="top"
  >
    <template #title
      >{{ title_prefix }}
      {{ is_display_name ? viewComponentModel.user_name.en : '' }}
    </template>
    <a
      v-if="!user_info.id"
      @click="onViewMoreClick"
      class="text-primary font-12"
      style="cursor: pointer"
    >
      View more
      <i class="mdi mdi-chevron-double-down"></i>
    </a>
    <div v-else>
      <template v-if="!is_display_name">
        <span
          ><b>ชื่อ-นามสกุล:</b> {{ user_info.first_name.th }}
          {{ user_info.last_name.th }}
        </span>
        <br />
      </template>
      <span
        ><b>อีเมล: </b>
        {{ user_info.email }}
      </span>
      <br />
      <template
        v-if="
          isVendor &&
            user_info.user_operator &&
            user_info.user_operator.employee_info
        "
      >
        <span
          ><b>รหัสผู้ขาย:</b>
          {{
            vendor_info &&
            vendor_info.vendor_partners &&
            vendor_info.vendor_partners.some(f => f.partner === 'OFM')
              ? vendor_info.vendor_partners.find(f => f.partner === 'OFM').code
              : ''
          }}<br />
        </span>
      </template>
      <template
        v-else-if="
          user_info.user_operator && user_info.user_operator.employee_info
        "
      >
        <span
          ><b>รหัสพนักงาน:</b>
          {{ user_info.user_operator.employee_info.crc_id }}
        </span>
        <br />
        <span v-if="viewComponentModel.user_type === 'Operator'"
          ><b>แผนก: </b>
          {{ user_info.user_operator.employee_info.department_name }}
        </span>
      </template>
      <template v-if="vendor_info && vendor_info.id">
        <!-- <span
          ><b>ชื่อนามสกุลภาษาอังกฤษ: </b>
          {{ vendor_info.display_name.en }}
        </span>
        <br /> -->
        <!-- <span
          ><b>ชื่อนามสกุลภาษาไทย: </b>
=======
        <span v-if="isVendor === false"
          ><b>ชื่อนามสกุลภาษาอังกฤษ: </b>
          {{ vendor_info.display_name.en }}
        </span>
        <br />
        <span
          ><b>{{ isVendor ? 'ชื่อผู้ขาย:' : 'ชื่อนามสกุลภาษาไทย:' }} </b>
          {{ vendor_info.display_name.th }}
        </span>
        <br /> -->
        <span
          ><b>ชื่อผู้ขาย: </b>
          {{ vendor_info.display_name.th }}
        </span>
        <br />
        <span
          ><b>ประเภทผู้ขาย: </b>
          {{ vendor_info.type }}
        </span>
      </template>
    </div>
  </b-popover>
</template>

<script>
import userService from '@/helpers/service/user-provider'
import vendorService from '@/helpers/service/vendor-service'

export default {
  name: 'UserInfoPopover',
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {
        return this.viewComponentModel
      },
    },
    target_id: {
      type: String,
      default: () => {
        return ''
      },
    },
    title_prefix: {
      type: String,
      default: () => {
        return ''
      },
    },
    is_display_name: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    is_vendor: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  mounted() {},
  data() {
    return {
      viewComponentModel: {
        user_open_id: 'string',
        user_type: 'string',
        user_code: 'string',
        user_name: {
          th: 'string',
          en: 'string',
        },
      },
      user_info: {},
      vendor_info: {},
    }
  },
  created: function() {
    if (this.value) this.viewComponentModel = this.value
  },
  watch: {
    value: {
      handler(val) {
        this.viewComponentModel = val
      },
      deep: true,
    },
  },
  computed: {
    isVendor() {
      let isVendorFlag = false
      if (this.is_vendor) {
        isVendorFlag = this.is_vendor
      } else if (this.viewComponentModel && this.viewComponentModel.user_type) {
        isVendorFlag = this.viewComponentModel.user_type === 'Vendor'
      }

      return isVendorFlag
    },
  },
  methods: {
    async onViewMoreClick() {
      let result = await userService.getUserAsync(
        this.viewComponentModel.user_open_id
      )
      if (result.status === 200) {
        this.user_info = result.data
      }

      if (this.viewComponentModel.user_type === 'Vendor') {
        let resultVendor = await vendorService.getVendorMasterDetailAsync(
          this.viewComponentModel.user_code
        )
        if (resultVendor.status === 200) {
          this.vendor_info = resultVendor.data
        }
      }
    },
  },
}
</script>
